<!--
 * @Author: xing.huang
 * @Date: 2020-11-27 15:12:53
 * @LastEditTime: 2020-12-09 14:36:03
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\components\common\boardConfig.vue
 * @
-->
<template>
  <el-dialog title="配置机组看板显示" @close="cancelViewDialog" :visible.sync="viewDialogVisible" width="66%" center :close-on-click-modal="false">
    <div class="container">
      <el-card class="box-card1">
        <div class="top-container">
          <div
            class="cls-default list1"
            v-for="(item, index) in list1"
            :key="index"
            :data-id="index"
            :draggable="item.draggable"
            @dragstart="onDragstart($event)"
            @dragend="onDragend($event)"
            @dragover="onDragover($event)"
            @drop="onDrop($event)"
            @mouseover="showpic"
            :style="{ 'background-image': `url(${item.url})` }"
          >
            <div class="move-pic" v-if="selectType == item.type"></div>
          </div>
        </div>
      </el-card>
      <el-card class="box-card2">
        <div style="text-align:center">
          <span class="sub-title">拖拽上方图表样式到两侧区域</span>
        </div>
        <div class="bottom-container">
          <div
            class="cls-default list2"
            v-for="(item, index) in list2"
            :key="index"
            :data-id="index"
            :draggable="item.draggable"
            @dragstart="onDragstart($event)"
            @dragend="onDragend($event)"
            @dragover="onDragover($event)"
            @drop="onDrop($event)"
            :style="{ 'background-image': `url(${item.url})` }"
            :class="{ 'cls1-1': index == 1 }"
          ></div>
        </div>
      </el-card>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="submitConfig" type="primary">确 定</el-button>
      <el-button @click="cancelViewDialog">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: true
  },
  name: "BoardConfig",
  data() {
    return {
      selectType: null,
      viewDialogVisible: false,
      stargindex: "",
      endIndex: "",
      list1: [
        {
          id: 0,
          type: 0,
          index: 99,
          title: "当月工单状态",
          draggable: true,
          url: "/static/img/boardbg/0.png"
        },
        {
          id: 1,
          type: 1,
          index: 99,
          draggable: true,
          title: "产量走势图",
          url: "/static/img/boardbg/1.png"
        },
        {
          id: 2,
          type: 2,
          index: 99,
          draggable: true,
          title: "到岗员工走势",
          url: "/static/img/boardbg/2.png"
        },
        {
          id: 3,
          type: 3,
          index: 99,
          draggable: true,
          title: "员工日产量",
          url: "/static/img/boardbg/3.png"
        },
        {
          id: 4,
          type: 4,
          index: 99,
          draggable: true,
          title: "机组合格率走势",
          url: "/static/img/boardbg/4.png"
        },
        {
          id: 5,
          type: 5,
          index: 99,
          draggable: true,
          title: "工序日产量",
          url: "/static/img/boardbg/5.png"
        }
      ],
      list2: [
        {
          id: 6,
          type: 0,
          index: 0,
          draggable: true,
          title: "当月工单状态",
          url: "/static/img/boardbg/0.png"
        },
        {
          id: 7,
          type: 6,
          index: -1,
          draggable: false,
          title: "当前制品情况",
          url: "/static/img/boardbg/6.png"
        },
        {
          id: 8,
          type: 3,
          index: 1,
          draggable: true,
          title: "员工日产量",
          url: "/static/img/boardbg/3.png"
        },
        {
          id: 9,
          type: 1,
          index: 2,
          draggable: true,
          title: "产量走势图",
          url: "/static/img/boardbg/1.png"
        },
        {
          id: 10,
          type: 4,
          index: 3,
          draggable: true,
          title: "机组合格率走势",
          url: "/static/img/boardbg/4.png"
        }
      ]
    };
  },
  methods: {
    submitConfig() {
      let dataList = this.list2
        .filter(item => item.index > -1)
        .map(item => {
          return { boardType: item.type };
        });
      this.$RequestUtil.post({
        url: "/api/subscriptionBoardConfig/updateSubscriptionBoardConfig",
        type: "sync",
        params: { dataList },
        success: res => {
          this.$parent.isShow = false;
          this.viewDialogVisible = false;
          localStorage.setItem("boardConfig", JSON.stringify(dataList));
        }
      });
    },

    cancelViewDialog() {
      this.$parent.isShow = false;
    },

    showpic(event) {
      let index = event.target.getAttribute("data-id");
      this.selectType = this.list1[index].type;
    },

    onDragstart(event) {
      this.stargindex = event.target.getAttribute("data-id");
      log(this.stargindex, 1110000);
    },

    async loadConfig() {
      let { data, code } = await this.$RequestUtil.getAsync({ url: "/api/subscriptionBoardConfig/listSubscriptionBoardConfig", params: {} });
      return data;
    },

    onDragend(event) {
      // 对数据做简单的深拷贝 目前不需要
      // let endObj = JSON.parse(
      //   JSON.stringify(this.data[endGroupIndex].children[endChildIndex])
      // );
      // let startObj = JSON.parse(
      //   JSON.stringify(this.data[startGroupIndex].children[startChildIndex])
      // );
      let endObj = this.list2[this.endIndex];
      let startObj = this.list1[this.stargindex];
      if (event.target.className.indexOf("list2") > -1) {
        log(event.target.className, 666);
        return;
      }
      if (endObj.index == -1) {
        //往资源区拖拽时  不做任何替换操作
        return;
      }

      this.list2.splice(this.endIndex, 1, startObj);
      this.selectType = null;
      // if (this.data[startGroupIndex].group !== "source") {
      //     //拖拽起始区域不是 source时  把起始区域替换成拖拽后区域的数据
      //     this.data[startGroupIndex].children.splice(startChildIndex, 1, endObj);
      // }
    },

    onDrop(event) {
      if (event.target.className.indexOf("cls-default") > -1) {
        this.endIndex = event.target.getAttribute("data-id");
        log(this.endIndex, 201201);
      } else {
        this.endIndex = event.target.parentElement.getAttribute("data-id");
        log(this.endIndex, 202202);
      }
    },

    onDragover(event) {
      event.preventDefault();
    }
  },
  watch: {
    isShow: async function(newVal, oldVal) {
      this.viewDialogVisible = newVal;
      if (newVal == true) {
        let data = await this.loadConfig();
        data.splice(1, 0, this.list2[1]);
        this.list2.forEach((item, i) => {
          if (i != 1) {
            let temp = data[i];
            if (temp) {
              let [str1, str2] = item.url.split(".");
              str1 = str1.slice(0, -1) + temp.boardType + ".";
              item.url = str1 + str2;
              item.type = temp.boardType;
              item.id = temp.id;
            }
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.container {
  background-color: #eee;
  /* height: 600px; */
  overflow: hidden;
}

.cls-default {
  float: left;
  margin: 0;
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid #999;
  background-size: 100% 100%;
}
.cls-default .content {
  text-align: center;
  padding-top: 20px;
  font-size: 20px;
}
.bottom-container {
  margin: 15px auto;
  width: 696px;
  display: grid;
  grid-template-columns: 194px 304px 194px;
  grid-template-rows: 180px 180px;
  grid-auto-flow: row;
  background: #0b1321;
}
.bottom-container .cls-default {
  background-size: 100% 100%;
  border: 1px dashed green;
  margin: 1px;
}

.bottom-container .cls1-1 {
  grid-row-start: 1;
  grid-row-end: 3;
  grid-column-start: 2;
  margin: 10px;
}

.top-container {
  /* width: 1100px; */
  height: 120px;
  margin: 16px 0;
  justify-content: center;
  display: flex;
}
.top-container .cls-default {
  width: 130px;
  height: 120px;
  border: 1px dashed #999;
  margin: 0 5px;
}
.box-card1 {
  width: 70%;
  margin: 20px auto;
}

.box-card2 {
  width: 64%;
  margin: 15px auto;
}
.sub-title {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  color: 666;
}
.move-pic {
  background: url("/static/img/boardbg/7.png");
  width: 38px;
  height: 38px;
  margin: 41px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/common/boardConfig.vue